<template>
  <CustomTimeLine :items="items" />
</template>

<script>
import moment from 'moment';
import CustomTimeLine from 'custom-time-line';
import { getRequestHistory as _getRequestHistory } from '@/modules/materials-equipment/api.js';

import { materialsEquipmentRequestStatus } from '@/utils/constants/pei/materials-equipment/MaterialsEquipmentRequestStatus';

export default {
  name: 'History',
  components: {
    CustomTimeLine,
  },
  data() {
    return {
      items: [],
    };
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
  },
  async mounted() {
    this.onLoadRequestHistory();
  },
  methods: {
    getColorStatus(statusId) {
      let result = '';
      switch (statusId) {
        case materialsEquipmentRequestStatus.Sometido:
          result = '#F8EB7F';
          break;
        case materialsEquipmentRequestStatus.DevueltoEscuela:
        case materialsEquipmentRequestStatus.Aprobada:
        case materialsEquipmentRequestStatus.PendienteClasificacion:
          result = '#f8b184';
          break;
        default:
          result = '#b5c3bc';
          break;
      }
      return result;
    },
    async onLoadRequestHistory() {
      const result = (await _getRequestHistory(this.requestId)).data;
      this.items = result.map((item) => ({
        status: {
          text: item.statusName,
          color: this.getColorStatus(item.statusId),
        },
        date: moment(item.date).format('DD/MM/YYYY'),
        text: item.createdByFullName,
      }));
    },
  },
};
</script>
